// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1eE2X","notes":"Notes_notes__1F-Qk","note":"Notes_note__3uhfk","markdown":"Notes_markdown__2xXTL"};